import React, { useState } from 'react';
import { BadgeDollarSignIcon, BanknoteIcon, CalendarDaysIcon, CheckCircle2Icon, CircleDollarSignIcon, FlameIcon, LandmarkIcon, LightbulbIcon, PackageCheckIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
type Payout = {
  period: string;
  revenueShare: string;
  itemsSold: string;
  orders: string;
  totalSales: string;
};
const payouts: Payout[] = [{
  period: 'Jun 1, 2026',
  revenueShare: '$5,062',
  itemsSold: '96',
  orders: '63',
  totalSales: '$10,643'
}, {
  period: 'May 1, 2026',
  revenueShare: '$3,942',
  itemsSold: '102',
  orders: '71',
  totalSales: '$8,369'
}, {
  period: 'Apr 1, 2026',
  revenueShare: '$5,493',
  itemsSold: '111',
  orders: '88',
  totalSales: '$11,452'
}, {
  period: 'Mar 1, 2026',
  revenueShare: '$9,928',
  itemsSold: '285',
  orders: '190',
  totalSales: '$23,627'
}, {
  period: 'Feb 1, 2026',
  revenueShare: '$6,803',
  itemsSold: '278',
  orders: '149',
  totalSales: '$19,734'
}, {
  period: 'Jan 1, 2026',
  revenueShare: '$18,539',
  itemsSold: '304',
  orders: '225',
  totalSales: '$39,881'
}, {
  period: 'Dec 1, 2025',
  revenueShare: '$3,722',
  itemsSold: '174',
  orders: '61',
  totalSales: '$7,709'
}, {
  period: 'Nov 1, 2025',
  revenueShare: '$2,422',
  itemsSold: '106',
  orders: '68',
  totalSales: '$5,876'
}, {
  period: 'Oct 1, 2025',
  revenueShare: '$2,790',
  itemsSold: '148',
  orders: '91',
  totalSales: '$7,128'
}, {
  period: 'Sep 1, 2025',
  revenueShare: '$4,456',
  itemsSold: '192',
  orders: '81',
  totalSales: '$10,043'
}, {
  period: 'Aug 1, 2025',
  revenueShare: '$15,265',
  itemsSold: '670',
  orders: '224',
  totalSales: '$32,901'
}, {
  period: 'Jul 1, 2025',
  revenueShare: '$10,536',
  itemsSold: '527',
  orders: '218',
  totalSales: '$25,709'
}, {
  period: 'Jun 1, 2025',
  revenueShare: '$19,375',
  itemsSold: '698',
  orders: '379',
  totalSales: '$39,474'
}, {
  period: 'May 1, 2025',
  revenueShare: '$9,925',
  itemsSold: '449',
  orders: '192',
  totalSales: '$20,159'
}, {
  period: 'Apr 1, 2025',
  revenueShare: '$8,226',
  itemsSold: '354',
  orders: '111',
  totalSales: '$17,467'
}, {
  period: 'Mar 1, 2025',
  revenueShare: '$5,483',
  itemsSold: '213',
  orders: '100',
  totalSales: '$12,357'
}, {
  period: 'Feb 1, 2025',
  revenueShare: '$2,578',
  itemsSold: '74',
  orders: '47',
  totalSales: '$8,137'
}, {
  period: 'Jan 1, 2025',
  revenueShare: '-$697',
  itemsSold: '30',
  orders: '24',
  totalSales: '$3,187'
}, {
  period: 'Dec 1, 2024',
  revenueShare: '$44',
  itemsSold: '42',
  orders: '29',
  totalSales: '$4,388'
}, {
  period: 'Nov 1, 2024',
  revenueShare: '$3',
  itemsSold: '27',
  orders: '21',
  totalSales: '$2,778'
}, {
  period: 'Oct 1, 2024',
  revenueShare: '-$141',
  itemsSold: '41',
  orders: '31',
  totalSales: '$4,615'
}, {
  period: 'Sep 1, 2024',
  revenueShare: '$155',
  itemsSold: '49',
  orders: '34',
  totalSales: '$4,940'
}, {
  period: 'Aug 1, 2024',
  revenueShare: '$253',
  itemsSold: '92',
  orders: '66',
  totalSales: '$10,614'
}, {
  period: 'Jul 1, 2024',
  revenueShare: '-$67',
  itemsSold: '49',
  orders: '34',
  totalSales: '$5,869'
}, {
  period: 'Jun 1, 2024',
  revenueShare: '$627',
  itemsSold: '41',
  orders: '34',
  totalSales: '$6,526'
}];
export function FinancesDashboard({
  selectedOwner
}: {
  selectedOwner: string;
}) {
  const hasData = selectedOwner === 'Eddy';
  const [billConnected, setBillConnected] = useState(false);
  return <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8 lg:py-14" aria-labelledby="finances-heading" data-id="element-1250" data-mp="22n5cw5g7b77f">
      <section className="flex flex-col gap-5 border-b border-ink/10 pb-8 sm:flex-row sm:items-end sm:justify-between" data-id="element-1251" data-mp="1xlg30t4pszkx">
        <div data-id="element-1252" data-mp="27kx40x90upak">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#BB5E40]" data-id="element-1253" data-mp="27l6t8im8ssf7"><LandmarkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1254" data-mp="2lcv5clwhrgw6" />Finances</span>
          <h1 id="finances-heading" className="mt-3 font-display text-4xl font-medium tracking-tight sm:text-5xl" data-id="element-1255" data-mp="2gdilma0x2pxt">Payouts and recovery value</h1>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink/65 sm:text-lg" data-id="element-1256" data-mp="2vbavomnp2m4m">Review payouts, recovery share, and monthly performance across approved channels.</p>
        </div>
        <div className="flex w-fit flex-wrap items-center gap-2" data-id="element-1257" data-mp="nnq30l1wusmi"><button type="button" onClick={() => setBillConnected(true)} disabled={billConnected} className={`inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-xs font-semibold transition-colors ${billConnected ? 'border border-ink/15 bg-white text-ink/75' : 'bg-[#3D8B40] text-cream hover:bg-[#2F7032]'}`} data-id="element-1258" data-mp="snujib2tjncq">{billConnected ? <span aria-hidden="true" className="h-2 w-2 rounded-full bg-[#3D8B40]" data-id="element-1259" data-mp="4qezupd5rf1s" /> : <BanknoteIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1260" data-mp="9p04d0zg0kw1" />}{billConnected ? 'Connected to Bill.com' : 'Connect Bill.com'}</button><span className="inline-flex items-center gap-2 rounded-full bg-forest/8 px-3 py-1.5 text-xs font-semibold text-forest" data-id="element-1261" data-mp="enthgsati9vo"><span className="h-1.5 w-1.5 rounded-full bg-forest" data-id="element-1262" data-mp="jnxprv1knyat" />{selectedOwner || 'All brands'}</span></div>
      </section>

      {hasData ? <>
        <section className="mt-8 rounded-3xl border border-ink/10 bg-paper p-5 shadow-sm sm:p-7" aria-label="Payout summary" data-id="element-1263" data-mp="1q5kwe98sbc3u">
          <div className="grid gap-x-5 gap-y-6 sm:grid-cols-3" data-id="element-1264" data-mp="3fkvhc0k3jiqu">
            <FinanceMetric icon={BadgeDollarSignIcon} label="Total payouts" value="$134,721.42" detail="Paid across all periods" data-id="element-1265" data-mp="3fm6n25x3r0kl" />
            <FinanceMetric icon={PackageCheckIcon} label="Items paid out" value="5,152" detail="Units included in payouts" data-id="element-1266" data-mp="35u0tirr7cb3a" />
            <FinanceMetric icon={BanknoteIcon} label="Pending items" value="0" detail="Ready for next payout" data-id="element-1267" data-mp="30uo9eerpti4e" />
            <FinanceMetric icon={CircleDollarSignIcon} label="Average payout" value="$5,388.86" detail="Per paid period" data-id="element-1268" data-mp="2vxxtbrfwumiz" />
            <FinanceMetric icon={TrendingUpIcon} label="Average payout / item" value="$93.15" detail="Net recovery share" data-id="element-1269" data-mp="2rwvq6zivhqbq" />
            <FinanceMetric icon={CalendarDaysIcon} label="Latest payout" value="$5,061.82" detail="Up 28.4% vs. prior month" positive data-id="element-1270" data-mp="2hwv4x81g104w" />
          </div>
        </section>

        <section className="mt-5 grid gap-5 lg:grid-cols-3" aria-label="Payout insights" data-id="element-1271" data-mp="l28sy6wdpibo">
          <InsightCard icon={FlameIcon} title="Strong rebound this month" text="Your June payout of $5,061.82 is up 28.4% from May—a strong recovery after a softer month. There is meaningful upside as more inventory becomes active." data-id="element-1272" data-mp="g61jw58orqpi" />
          <InsightCard icon={LightbulbIcon} title="Fewer items, higher value per sale" text="June sold 96 items across 63 orders—your lowest item count in six months, yet your revenue held strong. Higher-ticket units are moving well." data-id="element-1273" data-mp="20nj5nnh443lq" />
          <InsightCard icon={TargetIcon} title="Restock to recapture peak volume" text="Your best months coincided with higher active inventory. Prioritizing listings is the clearest way to rebuild payout momentum." data-id="element-1274" data-mp="2tczs84i1wqa1" />
        </section>

        <section className="mt-5 overflow-hidden rounded-3xl border border-ink/10 bg-paper shadow-sm" aria-labelledby="payout-history-heading" data-id="element-1275" data-mp="2jfv5a2gdsqs6">
          <div className="flex items-center gap-2 border-b border-ink/10 px-5 py-5 sm:px-7" data-id="element-1276" data-mp="17yc7wqphfi1j"><LandmarkIcon className="h-4 w-4 text-[#BB5E40]" aria-hidden="true" data-id="element-1277" data-mp="1cxgi9ko57ltg" /><h2 id="payout-history-heading" className="text-lg font-semibold" data-id="element-1278" data-mp="1cvlvs1x83ln9">Payout history</h2></div>
          <div className="overflow-x-auto" data-id="element-1279" data-mp="3r7kc36cms95d"><table className="w-full min-w-[850px] text-left text-sm" data-id="element-1280" data-mp="3m6msqqfvx92a"><thead className="bg-cream/50 text-xs text-ink/50" data-id="element-1281" data-mp="3m64szju0kcpm"><tr data-id="element-1282" data-mp="419sl3q0nzpb"><th scope="col" className="px-5 py-3 font-semibold sm:px-7" data-id="element-1283" data-mp="411h9g9jl2g8">Status</th><th scope="col" className="px-3 py-3 font-semibold" data-id="element-1284" data-mp="3w4kixjhb1fxj">Payout period</th><th scope="col" className="px-3 py-3 text-right font-semibold" data-id="element-1285" data-mp="3w5c2fvxmnn7g">Revenue share</th><th scope="col" className="px-3 py-3 text-right font-semibold" data-id="element-1286" data-mp="38frl1hh4gy0a">Items sold</th><th scope="col" className="px-3 py-3 text-right font-semibold" data-id="element-1287" data-mp="33godnqdo6fp5">Total orders</th><th scope="col" className="px-5 py-3 text-right font-semibold sm:px-7" data-id="element-1288" data-mp="3h71l7rmnfsdy">Total sales</th></tr></thead><tbody className="divide-y divide-ink/10" data-id="element-1289" data-mp="3cgtlu2qoti4d">{payouts.map(payout => <tr key={payout.period} data-id="element-1290" data-mp="3cfa0hxq6cgvq"><td className="px-5 py-3 sm:px-7" data-id="element-1291" data-mp="2oqz9rne6zxl6"><span className="inline-flex items-center gap-1 rounded-full bg-forest/10 px-2.5 py-1 text-xs font-semibold text-forest" data-id="element-1292" data-mp="2oq7c8711bps9"><CheckCircle2Icon className="h-3 w-3" data-id="element-1293" data-mp="2kom1ar829lkp" />Paid</span></td><th scope="row" className="px-3 py-3 font-medium text-ink" data-id="element-1294" data-mp="39kg3wqs868zp">{payout.period}</th><td className="px-3 py-3 text-right font-semibold tabular-nums text-ink" data-id="element-1295" data-mp="39mj1bvvpj4eg">{payout.revenueShare}</td><td className="px-3 py-3 text-right tabular-nums text-ink/70" data-id="element-1296" data-mp="3el433zqlxw50">{payout.itemsSold}</td><td className="px-3 py-3 text-right tabular-nums text-ink/70" data-id="element-1297" data-mp="3ijjmltnhcmdo">{payout.orders}</td><td className="px-5 py-3 text-right font-semibold tabular-nums text-ink sm:px-7" data-id="element-1298" data-mp="3nkqxw2ou03p3">{payout.totalSales}</td></tr>)}</tbody></table></div>
        </section>
      </> : <section className="mt-8 rounded-3xl border border-dashed border-ink/15 bg-paper px-6 py-16 text-center" data-id="element-1299" data-mp="1c7or0kgup1y"><LandmarkIcon className="mx-auto h-6 w-6 text-[#BB5E40]" aria-hidden="true" data-id="element-1300" data-mp="637mu95bnd61" /><h2 className="mt-4 text-lg font-semibold" data-id="element-1301" data-mp="a51i21wqzoyt">Select an owner to view finances</h2><p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-ink/55" data-id="element-1302" data-mp="a75puuxrp84d">Payout history and recovery-share totals will appear for the selected brand.</p></section>}
    </div>;
}
function FinanceMetric({
  icon: Icon,
  label,
  value,
  detail,
  positive = false
}: {
  icon: typeof LandmarkIcon;
  label: string;
  value: string;
  detail: string;
  positive?: boolean;
}) {
  return <article className="border-[#BB5E40]/20 pl-4 first:border-l-0 first:pl-0 sm:[&:nth-child(3n+1)]:border-l-0 sm:[&:nth-child(3n+1)]:pl-0 sm:[&:not(:nth-child(3n+1))]:border-l-2" data-id="element-1303" data-mp="p7b1dgk5blz7"><Icon className="h-4 w-4 text-[#BB5E40]" aria-hidden="true" data-id="element-1304" data-mp="g868aprcskuf" /><p className="mt-4 text-sm text-ink/55" data-id="element-1305" data-mp="g9r2ge9ra1rr">{label}</p><p className="mt-1 font-display text-3xl font-semibold tracking-tight text-ink" data-id="element-1306" data-mp="1cwlxgkqjws70">{value}</p><p className={`mt-1 text-xs ${positive ? 'font-semibold text-forest' : 'text-ink/50'}`} data-id="element-1307" data-mp="17yaqchrn4vsh">{detail}</p></article>;
}
function InsightCard({
  icon: Icon,
  title,
  text
}: {
  icon: typeof FlameIcon;
  title: string;
  text: string;
}) {
  return <article className="rounded-2xl border border-ink/10 bg-paper p-5 sm:p-6" data-id="element-1308" data-mp="z60buo9pq45f"><Icon className="h-5 w-5 text-[#BB5E40]" aria-hidden="true" data-id="element-1309" data-mp="1vp6lnovb294h" /><h2 className="mt-4 text-lg font-semibold tracking-tight" data-id="element-1310" data-mp="1qxg8zc8wb99w">{title}</h2><p className="mt-3 text-sm leading-relaxed text-ink/65" data-id="element-1311" data-mp="1qw55ldjd43jb">{text}</p></article>;
}